import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { FileText, Mail, MessageSquare, PhoneMissed } from 'lucide-react';
import { MergeFieldTextInput } from './MergeFieldTextInput';

export const SuccessCoachingUnsuccessfulEditor = ({ value, mergeFields, onChange, readOnly }) => {
  const set = (k) => (v) => onChange({ ...value, [k]: v });
  return (
    <Card className="card-shadow border-amber-200" data-testid="sc-unsuccessful-templates">
      <CardHeader className="pb-3">
        <CardTitle className="text-base flex items-center gap-2"><PhoneMissed className="w-4 h-4 text-amber-600" />Unsuccessful Contact Templates</CardTitle>
        <CardDescription>Used for any week when "Unsuccessful call attempt" is turned on in the Success Coaching case note. Leave a template blank to not send it.</CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="space-y-2 rounded-md border p-3">
          <p className="text-sm font-medium flex items-center gap-1"><FileText className="w-4 h-4" />Case note template</p>
          <MergeFieldTextInput label="Note wording" multiline rows={6} value={value.case_note_body} mergeFields={mergeFields} disabled={readOnly}
            onChange={set('case_note_body')} testId="sc-unsuccessful-case-note" placeholder="The wording of the unsuccessful contact case note" />
        </div>
        <div className="grid md:grid-cols-2 gap-4">
          <div className="space-y-2 rounded-md border p-3">
            <p className="text-sm font-medium flex items-center gap-1"><Mail className="w-4 h-4" />Email to participant</p>
            <MergeFieldTextInput label="Subject" value={value.email_subject} mergeFields={mergeFields} disabled={readOnly}
              onChange={set('email_subject')} testId="sc-unsuccessful-email-subject" />
            <MergeFieldTextInput label="Body" multiline rows={6} value={value.email_body} mergeFields={mergeFields} disabled={readOnly}
              onChange={set('email_body')} testId="sc-unsuccessful-email-body" placeholder="Leave blank to not send an email" />
          </div>
          <div className="space-y-2 rounded-md border p-3">
            <p className="text-sm font-medium flex items-center gap-1"><MessageSquare className="w-4 h-4" />Text (SMS) to participant</p>
            <MergeFieldTextInput label="Message" multiline rows={6} value={value.sms_body} mergeFields={mergeFields} disabled={readOnly}
              onChange={set('sms_body')} testId="sc-unsuccessful-sms-body" placeholder="Leave blank to not send a text"
              footer={<p className="text-[11px] text-muted-foreground" data-testid="sc-unsuccessful-sms-length">{(value.sms_body || '').length} characters (before merge fields are filled in)</p>} />
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
